var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 994.42 350.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e2e8e7;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #e0323f;\n      }\n\n      .cls-3 {\n        fill: #dbe4e4;\n      }\n\n      .cls-4 {\n        fill: #0abcaa;\n      }\n\n      .cls-5 {\n        fill: #ff1e00;\n      }\n\n      .cls-6 {\n        fill: #dee6e6;\n      }\n\n      .cls-7 {\n        fill: #e2e2e2;\n      }\n\n      .cls-8 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.66,21.47c-.2-2.94-.24-5.94-.24-9.17.27-.05.73.12.73.28-.07,2.94-.2,5.88-.49,8.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.39,10.61c-.4-1.04-.66-2.2-.9-3.55,1.74.63,1.58,1.98.9,3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.03,1.59c-.5-.36-.98-.9-1.52-1.59.47.37,1,.89,1.52,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.42,3.07c-.45-.22-.9-.61-1.38-1.16.44.22.91.6,1.38,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.96,4.02c-.27-.12-.43-.32-.59-.67.23.1.47.34.59.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.52,64.47c-.07-.2.01-.4.18-.72.28.04.46.21.65.38-.23.12-.46.23-.83.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 116.8,
    cy: 338.04,
    rx: 65.13,
    ry: 12.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233.59,121.59c0,111.25-116.8,217.38-116.8,217.38,0,0-116.8-106.13-116.8-217.38C0,57.08,52.29,4.79,116.8,4.79s116.8,52.29,116.8,116.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 116.8,
    cy: 121.52,
    r: 101.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.8,27.25c-52.07,0-94.27,42.21-94.27,94.27s42.21,94.27,94.27,94.27,94.27-42.21,94.27-94.27S168.86,27.25,116.8,27.25ZM116.8,210.09c-48.92,0-88.57-39.65-88.57-88.57S67.88,32.95,116.8,32.95s88.57,39.65,88.57,88.57-39.66,88.57-88.57,88.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.27,104.48c0,57.77-71.48,91.72-71.48,91.72,0,0-71.48-33.95-71.48-91.72,0-19.81,16.5-35.87,36.86-35.87,15.89,0,29.43,9.79,34.61,23.5,5.18-13.71,18.72-23.5,34.61-23.5,20.36,0,36.86,16.06,36.86,35.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M122.44,171.06s-.08,0-.12,0c-.74-.05-1.34-.61-1.46-1.35l-8.41-55.03-7.06,31.77c-.16.7-.76,1.21-1.48,1.24-.72.03-1.37-.42-1.58-1.11l-5.12-16.26-1.93,4.2c-.26.56-.82.93-1.44.93h-24.16c-.88,0-1.59-.71-1.59-1.59s.71-1.59,1.59-1.59h23.14l3.23-7.02c.27-.6.89-.96,1.54-.92.66.04,1.22.48,1.42,1.11l4.58,14.53,7.61-34.27c.17-.75.85-1.27,1.6-1.24.76.03,1.4.59,1.52,1.35l8.64,56.52,11.16-36.56c.19-.61.73-1.05,1.36-1.12.64-.06,1.25.26,1.56.83l4.16,7.75h22.73c.88,0,1.59.71,1.59,1.59s-.71,1.59-1.59,1.59h-23.68c-.59,0-1.12-.32-1.4-.84l-2.8-5.22-12.08,39.58c-.21.67-.83,1.13-1.52,1.13Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M296.78,208.49l-13.95,35.55h-7.65l40.8-101.1h7.2l40.5,101.1h-7.65l-14.25-35.55h-45ZM339.38,202.34l-14.25-35.55c-2.7-6.75-4.05-11.1-5.55-16.05h-.3c-1.5,5.1-3.15,9.6-5.55,15.6l-14.4,36h40.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M433.88,240.59c-3.15,1.5-11.85,5.25-24.15,5.25-22.95,0-38.1-15.9-38.1-36.75,0-24,17.85-38.85,40.95-38.85,10.65,0,18.9,3,21.9,5.1l-2.7,6c-4.2-2.4-10.5-4.8-19.8-4.8-21.45,0-33,14.1-33,31.65,0,18.75,13.5,31.35,31.8,31.35,10.35,0,16.8-3,21-4.8l2.1,5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M462.83,150.74c0,3.3-2.4,6.45-6.3,6.45-3.45,0-5.85-3.15-5.85-6.45s2.7-6.45,6.15-6.45,6,3,6,6.45ZM453.08,244.04v-72h7.35v72h-7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M486.83,136.64h7.35v107.4h-7.35v-107.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M556.58,144.29c9-1.2,19.05-2.25,30.3-2.25,21.45,0,37.8,5.85,47.25,16.2,8.4,9.15,12.15,19.95,12.15,33,0,11.55-3.45,25.65-13.95,36.9-9.75,10.35-26.85,16.8-49.5,16.8-9.15,0-17.55-.15-26.25-.9v-99.75ZM563.93,237.89c4.8.75,12,.9,20.1.9,38.4,0,54.75-21.15,54.75-47.4.3-24.75-15.6-43.2-52.5-43.2-9.75,0-17.1.9-22.35,1.95v87.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M734.92,207.14c0,27-21,38.7-38.7,38.7-21.45,0-37.05-15.75-37.05-37.05,0-24,18-38.55,38.1-38.55,23.1,0,37.65,16.35,37.65,36.9ZM666.53,208.34c0,20.1,14.55,31.5,30.15,31.5s30.9-11.55,30.9-32.25c0-13.65-9.15-31.35-30.3-31.35s-30.75,15.3-30.75,32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M761.93,206.69h.3c1.95-2.25,5.4-5.85,7.95-8.25l28.05-26.4h9.3l-32.1,29.7,36.75,42.3h-9.15l-32.85-38.1-8.25,7.95v30.15h-7.35v-107.4h7.35v70.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M833.62,150.59v21.45h22.8v5.85h-22.8v46.05c0,8.85,2.7,15.6,11.55,15.6,4.35,0,7.35-.6,9.45-1.35l.9,5.7c-2.55,1.05-6.3,1.95-11.1,1.95-5.7,0-10.35-1.8-13.35-5.4-3.6-4.05-4.8-10.65-4.8-17.4v-45.15h-13.2v-5.85h13.2v-19.2l7.35-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M942.37,207.14c0,27-21,38.7-38.7,38.7-21.45,0-37.05-15.75-37.05-37.05,0-24,18-38.55,38.1-38.55,23.1,0,37.65,16.35,37.65,36.9ZM873.98,208.34c0,20.1,14.55,31.5,30.15,31.5s30.9-11.55,30.9-32.25c0-13.65-9.15-31.35-30.3-31.35s-30.75,15.3-30.75,32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M962.02,195.29c0-7.8-.15-15.45-.6-23.25h6.75l.3,15.6h.45c3.6-10.05,11.4-17.4,22.05-17.4,1.2,0,2.4.15,3.45.45v6.75c-1.35-.3-2.55-.3-4.2-.3-10.05,0-17.7,8.4-20.1,20.85-.45,2.1-.75,4.65-.75,7.05v39h-7.35v-48.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.27ae3e64ca4f8c5aac894a00b31e4719.svg";
export { ForwardRef as ReactComponent };